var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1122,
    height: 862,
    viewBox: "0 0 1122 862",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_3745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1169.93 -157.757 1013.32 -11.849 826.736 174.736C640.151 361.32 494.244 517.926 500.842 524.525C507.441 531.123 664.046 385.215 850.631 198.631C1037.22 12.0462 1183.12 -144.56 1176.52 -151.158Z",
    stroke: "url(#paint0_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1169.32 -158.366 1012.22 -12.9517 825.632 173.633C639.047 360.218 493.633 517.317 500.841 524.525C508.048 531.732 665.148 386.318 851.733 199.734C1038.32 13.1492 1183.73 -143.95 1176.52 -151.158Z",
    stroke: "url(#paint1_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.159C1168.71 -158.975 1011.11 -14.0551 824.53 172.53C637.945 359.114 493.025 516.708 500.842 524.524C508.658 532.341 666.252 387.421 852.836 200.836C1039.42 14.2515 1184.34 -143.342 1176.52 -151.159Z",
    stroke: "url(#paint2_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1168 -159.685 1009.83 -15.3413 823.243 171.243C636.658 357.828 492.314 515.997 500.841 524.525C509.369 533.052 667.538 388.708 854.123 202.123C1040.71 15.5387 1185.05 -142.631 1176.52 -151.158Z",
    stroke: "url(#paint3_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1167.29 -160.396 1008.54 -16.6279 821.957 169.957C635.373 356.541 491.605 515.287 500.843 524.525C510.081 533.763 668.826 389.995 855.411 203.41C1042 16.8253 1185.76 -141.92 1176.53 -151.158Z",
    stroke: "url(#paint4_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1166.47 -161.208 1007.07 -18.0984 820.485 168.486C633.901 355.071 490.791 514.475 500.841 524.525C510.891 534.575 670.295 391.465 856.879 204.88C1043.46 18.2958 1186.57 -141.108 1176.52 -151.158Z",
    stroke: "url(#paint5_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1165.56 -162.122 1005.42 -19.7526 818.832 166.832C632.247 353.417 489.878 513.561 500.842 524.525C511.806 535.488 671.95 393.119 858.535 206.535C1045.12 19.9502 1187.49 -140.194 1176.52 -151.158Z",
    stroke: "url(#paint6_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1164.65 -163.035 1003.76 -21.4071 817.177 165.178C630.592 351.762 488.964 512.647 500.841 524.525C512.718 536.402 673.603 394.773 860.188 208.189C1046.77 21.6042 1188.4 -139.281 1176.52 -151.158Z",
    stroke: "url(#paint7_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1163.63 -164.051 1001.92 -23.2453 815.338 163.339C628.754 349.924 487.948 511.632 500.841 524.524C513.733 537.417 675.441 396.611 862.026 210.027C1048.61 23.4422 1189.42 -138.266 1176.52 -151.158Z",
    stroke: "url(#paint8_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1162.41 -165.268 999.719 -25.4507 813.134 161.134C626.55 347.719 486.732 510.414 500.842 524.525C514.953 538.635 677.649 398.818 864.233 212.233C1050.82 25.6483 1190.64 -137.047 1176.52 -151.158Z",
    stroke: "url(#paint9_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1161.2 -166.487 997.512 -27.6565 810.928 158.928C624.343 345.513 485.513 509.196 500.842 524.525C516.171 539.853 679.854 401.023 866.438 214.439C1053.02 27.8539 1191.85 -135.829 1176.52 -151.158Z",
    stroke: "url(#paint10_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1159.88 -167.806 995.123 -30.0458 808.538 156.539C621.954 343.123 484.193 507.876 500.842 524.525C517.49 541.173 682.243 403.413 868.828 216.828C1055.41 30.2436 1193.17 -134.509 1176.52 -151.158Z",
    stroke: "url(#paint11_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1158.45 -169.228 992.549 -32.6194 805.964 153.965C619.379 340.55 482.771 506.455 500.841 524.525C518.91 542.594 684.816 405.986 871.4 219.401C1057.98 32.8167 1194.59 -133.088 1176.52 -151.158Z",
    stroke: "url(#paint12_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1156.93 -170.751 989.793 -35.3766 803.209 151.208C616.624 337.793 481.25 504.932 500.843 524.525C520.435 544.117 687.575 408.743 874.159 222.158C1060.74 35.5738 1196.12 -131.566 1176.53 -151.158Z",
    stroke: "url(#paint13_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1155.21 -172.476 986.668 -38.5012 800.083 148.083C613.499 334.668 479.524 503.207 500.842 524.525C522.16 545.843 690.699 411.868 877.283 225.283C1063.87 38.6986 1197.84 -129.84 1176.52 -151.158Z",
    stroke: "url(#paint14_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1153.28 -174.405 983.176 -41.9935 796.592 144.591C610.007 331.176 477.596 501.278 500.843 524.525C524.09 547.772 694.192 415.36 880.776 228.776C1067.36 42.1912 1199.77 -127.911 1176.53 -151.158Z",
    stroke: "url(#paint15_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1151.35 -176.334 979.683 -45.4862 793.098 141.098C606.514 327.683 475.666 499.349 500.842 524.524C526.017 549.7 697.683 418.852 884.268 232.268C1070.85 45.6832 1201.7 -125.983 1176.52 -151.158Z",
    stroke: "url(#paint16_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1149.11 -178.567 975.638 -49.53 789.054 137.055C602.469 323.639 473.432 497.115 500.841 524.524C528.25 551.934 701.726 422.896 888.311 236.312C1074.9 49.727 1203.93 -123.749 1176.52 -151.158Z",
    stroke: "url(#paint17_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1146.78 -180.902 971.411 -53.7576 784.826 132.827C598.241 319.412 471.097 494.781 500.841 524.524C530.585 554.268 705.954 427.124 892.538 240.539C1079.12 53.9546 1206.27 -121.414 1176.52 -151.158Z",
    stroke: "url(#paint18_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1144.14 -183.541 966.632 -58.5365 780.048 128.048C593.463 314.633 468.458 492.141 500.841 524.525C533.225 556.908 710.733 431.903 897.318 245.318C1083.9 58.7338 1208.91 -118.775 1176.52 -151.158Z",
    stroke: "url(#paint19_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1141.3 -186.384 961.485 -63.6832 774.901 122.901C588.316 309.486 465.616 489.299 500.841 524.525C536.067 559.75 715.88 437.05 902.464 250.465C1089.05 63.8804 1211.75 -115.932 1176.52 -151.158Z",
    stroke: "url(#paint20_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1138.25 -189.43 955.971 -69.1977 769.386 117.387C582.802 303.972 462.57 486.253 500.841 524.524C539.112 562.795 721.394 442.564 907.978 255.979C1094.56 69.3944 1214.79 -112.887 1176.52 -151.158Z",
    stroke: "url(#paint21_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1134.9 -192.779 949.905 -75.2633 763.32 111.321C576.736 297.906 459.219 482.903 500.841 524.524C542.462 566.146 727.459 448.629 914.044 262.045C1100.63 75.4602 1218.14 -109.537 1176.52 -151.158Z",
    stroke: "url(#paint22_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1131.35 -196.332 943.473 -81.6965 756.888 104.888C570.304 291.473 455.668 479.35 500.842 524.525C546.016 569.699 733.894 455.063 920.478 268.478C1107.06 81.8937 1221.7 -105.984 1176.52 -151.158Z",
    stroke: "url(#paint23_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1127.39 -200.291 936.305 -88.865 749.72 97.7197C563.136 284.304 451.709 475.391 500.843 524.525C549.976 573.658 741.063 462.232 927.648 275.647C1114.23 89.0623 1225.66 -102.025 1176.53 -151.158Z",
    stroke: "url(#paint24_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1123.13 -204.555 928.584 -96.585 741.999 89.9996C555.415 276.584 447.445 471.128 500.842 524.525C554.238 577.921 748.782 469.951 935.366 283.367C1121.95 96.7822 1229.92 -97.7612 1176.52 -151.158Z",
    stroke: "url(#paint25_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1118.46 -209.225 920.129 -105.04 733.544 81.5442C546.959 268.129 442.775 466.458 500.842 524.524C558.908 582.591 757.237 478.407 943.822 291.822C1130.41 105.237 1234.59 -93.0917 1176.52 -151.158Z",
    stroke: "url(#paint26_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1113.38 -214.301 910.937 -114.231 724.353 72.3536C537.768 258.938 437.698 461.382 500.841 524.524C563.983 587.667 766.427 487.597 953.011 301.012C1139.6 114.428 1239.67 -88.016 1176.52 -151.158Z",
    stroke: "url(#paint27_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1107.9 -219.782 901.012 -124.156 714.427 62.4283C527.843 249.013 432.217 455.9 500.841 524.525C569.465 593.149 776.353 497.523 962.937 310.938C1149.52 124.354 1245.15 -82.5339 1176.52 -151.158Z",
    stroke: "url(#paint28_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1102.01 -225.67 890.352 -134.817 703.768 51.7675C517.183 238.352 426.331 450.013 500.843 524.525C575.355 599.037 787.015 508.184 973.6 321.599C1160.18 135.015 1251.04 -76.6458 1176.53 -151.158Z",
    stroke: "url(#paint29_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1095.51 -232.167 878.587 -146.581 692.002 40.0031C505.418 226.588 419.832 443.515 500.841 524.524C581.85 605.533 798.777 519.947 985.362 333.363C1171.95 146.778 1257.53 -70.1495 1176.52 -151.158Z",
    stroke: "url(#paint30_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1088.41 -239.273 865.721 -159.448 679.136 27.1369C492.552 213.721 412.726 436.41 500.842 524.525C588.957 612.64 811.645 532.814 998.229 346.23C1184.81 159.645 1264.64 -63.043 1176.52 -151.158Z",
    stroke: "url(#paint31_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1080.8 -246.887 851.936 -173.233 665.352 13.3512C478.767 199.936 405.114 428.796 500.842 524.525C596.571 620.253 825.431 546.6 1012.02 360.015C1198.6 173.431 1272.25 -55.4294 1176.53 -151.158Z",
    stroke: "url(#paint32_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1072.47 -255.211 836.864 -188.306 650.279 -1.72117C463.695 184.863 396.79 420.472 500.843 524.525C604.896 628.578 840.504 561.672 1027.09 375.088C1213.67 188.503 1280.58 -47.1052 1176.53 -151.158Z",
    stroke: "url(#paint33_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1063.44 -264.246 820.505 -204.665 633.92 -18.0802C447.336 168.504 387.755 411.437 500.842 524.525C613.93 637.612 856.863 578.031 1043.45 391.447C1230.03 204.862 1289.61 -38.0703 1176.53 -151.158Z",
    stroke: "url(#paint34_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1053.59 -274.093 802.675 -222.494 616.091 -35.9096C429.506 150.675 377.908 401.59 500.842 524.525C623.777 647.459 874.692 595.861 1061.28 409.276C1247.86 222.692 1299.46 -28.2233 1176.52 -151.158Z",
    stroke: "url(#paint35_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1042.93 -284.752 783.376 -241.794 596.791 -55.2095C410.206 131.375 367.249 390.931 500.843 524.525C634.436 658.118 893.992 615.161 1080.58 428.576C1267.16 241.992 1310.12 -17.5643 1176.53 -151.158Z",
    stroke: "url(#paint36_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1031.26 -296.426 762.238 -262.932 575.653 -76.3477C389.068 110.237 355.575 379.257 500.843 524.525C646.111 669.793 915.13 636.299 1101.72 449.714C1288.3 263.13 1321.79 -5.89016 1176.53 -151.158Z",
    stroke: "url(#paint37_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C1018.67 -309.014 739.444 -285.725 552.86 -99.1402C366.275 87.4444 342.986 366.669 500.842 524.524C658.698 682.38 937.922 659.091 1124.51 472.506C1311.09 285.922 1334.38 6.69765 1176.52 -151.158Z",
    stroke: "url(#paint38_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.53 -151.158C1004.86 -322.82 714.447 -310.723 527.863 -124.138C341.278 62.4465 329.181 352.863 500.843 524.525C672.505 696.186 962.921 684.089 1149.51 497.505C1336.09 310.92 1348.19 20.5038 1176.53 -151.158Z",
    stroke: "url(#paint39_linear_415_3745)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.52 -151.158C989.94 -337.743 687.426 -337.743 500.842 -151.158C314.257 35.4265 314.257 337.94 500.842 524.525C687.426 711.109 989.94 711.109 1176.52 524.524C1363.11 337.94 1363.11 35.4264 1176.52 -151.158Z",
    stroke: "url(#paint40_linear_415_3745)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_415_3745",
    x1: 512.79,
    y1: 536.472,
    x2: 485.969,
    y2: 509.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_415_3745",
    x1: 513.891,
    y1: 537.575,
    x2: 484.607,
    y2: 508.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_415_3745",
    x1: 514.995,
    y1: 538.677,
    x2: 483.249,
    y2: 506.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_415_3745",
    x1: 516.281,
    y1: 539.965,
    x2: 481.667,
    y2: 504.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_415_3745",
    x1: 517.569,
    y1: 541.251,
    x2: 480.089,
    y2: 503.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_415_3745",
    x1: 519.038,
    y1: 542.722,
    x2: 478.286,
    y2: 501.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_415_3745",
    x1: 520.693,
    y1: 544.376,
    x2: 476.264,
    y2: 499.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_415_3745",
    x1: 522.347,
    y1: 546.03,
    x2: 474.246,
    y2: 497.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_415_3745",
    x1: 524.185,
    y1: 547.868,
    x2: 472.01,
    y2: 494.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_415_3745",
    x1: 526.392,
    y1: 550.074,
    x2: 469.336,
    y2: 491.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_415_3745",
    x1: 528.597,
    y1: 552.28,
    x2: 466.669,
    y2: 489.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_415_3745",
    x1: 530.987,
    y1: 554.67,
    x2: 463.79,
    y2: 485.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_415_3745",
    x1: 533.559,
    y1: 557.243,
    x2: 460.699,
    y2: 482.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_415_3745",
    x1: 536.318,
    y1: 560,
    x2: 457.403,
    y2: 478.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_415_3745",
    x1: 539.442,
    y1: 563.125,
    x2: 453.682,
    y2: 474.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_415_3745",
    x1: 542.935,
    y1: 566.617,
    x2: 449.545,
    y2: 470.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_415_3745",
    x1: 546.426,
    y1: 570.109,
    x2: 445.427,
    y2: 465.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_415_3745",
    x1: 550.469,
    y1: 574.153,
    x2: 440.688,
    y2: 460.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_415_3745",
    x1: 554.697,
    y1: 578.381,
    x2: 435.765,
    y2: 454.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_415_3745",
    x1: 559.477,
    y1: 583.16,
    x2: 430.239,
    y2: 448.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_415_3745",
    x1: 564.623,
    y1: 588.306,
    x2: 424.334,
    y2: 441.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_415_3745",
    x1: 570.137,
    y1: 593.82,
    x2: 418.06,
    y2: 433.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_415_3745",
    x1: 576.202,
    y1: 599.886,
    x2: 411.223,
    y2: 425.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_415_3745",
    x1: 582.637,
    y1: 606.32,
    x2: 404.047,
    y2: 416.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_415_3745",
    x1: 589.806,
    y1: 613.488,
    x2: 396.141,
    y2: 406.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_415_3745",
    x1: 597.525,
    y1: 621.208,
    x2: 387.732,
    y2: 395.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_415_3745",
    x1: 605.98,
    y1: 629.663,
    x2: 378.651,
    y2: 383.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_415_3745",
    x1: 615.17,
    y1: 638.854,
    x2: 368.934,
    y2: 370.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_415_3745",
    x1: 625.096,
    y1: 648.78,
    x2: 358.62,
    y2: 356.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_415_3745",
    x1: 635.759,
    y1: 659.441,
    x2: 347.754,
    y2: 340.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_415_3745",
    x1: 647.521,
    y1: 671.204,
    x2: 336.016,
    y2: 323.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_415_3745",
    x1: 660.388,
    y1: 684.071,
    x2: 323.489,
    y2: 303.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_415_3745",
    x1: 674.175,
    y1: 697.857,
    x2: 310.43,
    y2: 283.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_415_3745",
    x1: 689.247,
    y1: 712.929,
    x2: 296.584,
    y2: 260.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_415_3745",
    x1: 705.606,
    y1: 729.288,
    x2: 282.073,
    y2: 234.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_415_3745",
    x1: 723.435,
    y1: 747.118,
    x2: 266.875,
    y2: 206.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_415_3745",
    x1: 742.736,
    y1: 766.418,
    x2: 251.16,
    y2: 176.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_415_3745",
    x1: 763.874,
    y1: 787.556,
    x2: 234.834,
    y2: 141.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_415_3745",
    x1: 786.665,
    y1: 810.348,
    x2: 218.279,
    y2: 104.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_415_3745",
    x1: 811.664,
    y1: 835.346,
    x2: 201.389,
    y2: 62.7964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_415_3745",
    x1: 838.683,
    y1: 862.366,
    x2: 184.634,
    y2: 17.0746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CEBC7",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#4ABDCC",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_3745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1734,
    height: 1320,
    fill: "white",
    transform: "translate(0 -458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundJob);
export default __webpack_public_path__ + "static/media/background-job.4f410167b0d5b4cb2a5f3cbe5204d156.svg";
export { ForwardRef as ReactComponent };